import * as React from 'react';
import { PageProps } from "src/models/common/ComponentProps";
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserDemo from 'src/games/demos/phaserDemo/Main';

interface PhaserGameDemoProps extends PageProps<{}> {
}

class PhaserGameDemo extends React.Component<PhaserGameDemoProps> {
    private game: Phaser.Game;
    constructor(props: PhaserGameDemoProps) {
        super(props);
        bindAllOfThis(this, PhaserGameDemo.prototype);
    }

    render() {
        return (<div>
            <PhaserDemo />
        </div>);
    }
}

export default PhaserGameDemo;



// WEBPACK FOOTER //
// ./src/pages/game/demos/PhaserGameDemo.tsx